import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {confirmAlert} from 'react-confirm-alert';
import {BeatLoader} from 'react-spinners';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import "../assets/css/monthpicker/month-picker.css";
import {css} from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import { List } from 'react-virtualized';
import ModalD from "react-awesome-modal";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var monthOptions = [];
var monthOptions_task = [];
for(var i=0; i<=23; i++){
    let date2 = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    //console.log("currDate"); console.log(date2);
    let monthd = date2.setMonth(date2.getMonth() -i);
    date2 = date2.toDateString();
    date2 = new Date(date2);
    let month2 = getMonth(date2);
    let year2 = date2.getFullYear();
    let monthName2 = monthNames[date2.getMonth()];
    var isDisable = true;
    if(month2 == '06' || month2 == '07'){
        isDisable = false;
    }
    monthOptions.push({ value: month2+'_'+year2, label: monthName2+' '+year2});
    if(i>=12) {
        monthOptions_task.push({ value: month2+year2, label: monthName2+' '+year2})
    }

}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var tod1 = moment(todayDate).format('MM/DD/YYYY');
var yest1 = moment(yesterday).format('MM/DD/YYYY');
var todShow1 = moment(todayDate).format('D MMM YYYY');
var yestShow1 = moment(yesterday).format('D MMM YYYY');
var todSend1 = moment(todayDate).format('YYYY-MM-DD');
var yestSend1 = moment(yesterday).format('YYYY-MM-DD');


var date_limit = moment(todayDate).format('MM/DD/YYYY');
class TableauDataMgt extends Component{
    constructor(props) {
        super(props);
        this.state = {
           kpi_data:[],
           loading:true,
        };
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({email:decoded.email});
        this.get_admin_kpi();

    }
    get_admin_kpi() {

        this.setState({
            loading: true
        });
        if ($.fn.DataTable.isDataTable('#KpiTable')) {
            $('#KpiTable').DataTable().destroy();
        }
        
         axios.post(config.get('API_URL')+'/tableau/get-admin-kpi/',
         {

         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
             console.log("res", response)
             var tdata =  [];
             if (Array.isArray(response.data) && response.data.length) {
                 tdata = response.data;

                 this.setState({
                     kpi_data: tdata,
                     loading:false
                 });
             } else {

             tdata = response.data;
                 this.setState({
                     kpi_data: tdata,
                     loading:false
                 })
             }
             $('#KpiTable').DataTable();

        }).catch( err => {
            console.log(err);
        });
    }

    render() {
        let KpiTableData = this.state.kpi_data.map((val,index) => {
            return (
                <tr key={index + 1}>
                    <td>{val["kpi_id"]}</td>
                    <td>{val["parent_kpi_id"]}</td>
                    <td>{val["title"]}</td>
                    <td>{val["link"]}</td>

                </tr>
            )
        });
        return(
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <NotificationSystem ref="notificationSystem" style={style}/>
                                <div className="content">
                                    <div className="row">
                                        <NotificationSystem ref="notificationSystem" style={style} />

                                    </div>
                                </div>
                                <hr className="m-0 p-0"/>
                                <div className="content table-full-width table-responsive nomargin">

                                    <div className="header">
                                        <h4 className="title">Tableau Data Mgt</h4>
                                    </div>
                                    <table id="KpiTable" className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            <th>KPI ID</th>
                                            <th>Parent KPI ID</th>
                                            <th>Title</th>
                                            <th>Link</th>
{/*                                             <th className="text-center">Start</th> */}
{/*                                             <th className="text-center">Stop</th> */}
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {KpiTableData}
                                        </tbody>

                                    </table>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />

                                </div>
                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        );
    }
}

export default TableauDataMgt